import { React, useEffect, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/ArrowForwardIos";
import MDTypography from "components/MDTypography";
import { TextField } from "@mui/material";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
function MultiSelectTreeView(props) {
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    // Toggle Nav
    const toggler = document.getElementsByClassName("caret");

    // Convert HTMLCollection to an array
    const togglerArray = Array.from(toggler);

    for (const element of togglerArray) {
      element.addEventListener("click", function (event) {
        const nested =
          event.currentTarget.parentElement.querySelector(".nested");
        if (nested) {
          // Check if nested is not null
          nested.classList.toggle("active");
        }
        event.currentTarget.classList.toggle("caret-down");
      });
    }
  }, []);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    props.searchedData(e.target.value);
  };

  return (
    <>
      <TextField
        className="outlined-basic-subject search-doc my-2"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleInputChange}
        autoComplete="off"
      />
      <MDTypography
        variant="p"
        fontSize="13px"
        fontWeight="regular"
        fontFamily="inherit"
        color="white"
      >
        <li className=" docs-nav ver-nav">
          <span className="caret">
            <Link to="/products/trading-api-v6.0">
              <MDTypography
                variant="h6"
                fontSize="13px"
                fontWeight="regular"
                fontFamily="inherit"
              >
                <div data-to-scrollspy-id="version">
                  Trading API - v6.0
                  <KeyboardArrowRightIcon />
                </div>
              </MDTypography>
            </Link>
          </span>
        </li>
        <li className=" docs-nav ver-nav">
          <span className="caret caret-down">
            <a href="#versions">
              <MDTypography
                variant="h6"
                fontSize="13px"
                fontWeight="regular"
                fontFamily="inherit"
              >
                <div data-to-scrollspy-id="versions">
                  Trading API - v2.5.3
                  <KeyboardArrowRightIcon />
                </div>
              </MDTypography>
            </a>
          </span>
          <ul className="docs-nav nested active">
            <li>
              <a href="#introduction">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="introduction">Introduction</div>
                </MDTypography>
              </a>
            </li>
            <li>
              <a href="#environment ">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="environment">Environment</div>
                </MDTypography>
              </a>
            </li>
            <li>
              <span className="caret">
                <a href="#authorizations">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="authorizations">
                      Authorizations
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <span className="caret">
                    <a href="#request-access-token">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="request-access-token">
                          Request Access Token
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#request-access-token-request-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#request-access-token-request-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#request-access-token-request-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#request-access-token-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#request-access-token-error">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#renew-access-token">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="renew-access-token">
                          Renew (Refresh) Access Token
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#renew-access-token-request-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#renew-access-token-request-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#renew-access-token-request-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#renew-access-token-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#renew-access-token-error">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#static-data">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="static-data">
                      Static Data
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <span className="caret">
                    <a href="#static-data-accounts">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="static-data-accounts">
                          Accounts
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#static-data-accounts-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-accounts-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-accounts-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Response Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#static-data-accounts-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#static-data-accounts-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#static-data-sides">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="static-data-sides">
                          Sides
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#static-data-sides-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-sides-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-sides-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Response Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#static-data-sides-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#static-data-sides-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#static-data-time-in-force">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="static-data-time-in-force">
                          Time In Force
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#static-data-tif-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-tif-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-tif-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Response Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#static-data-tif-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#static-data-tif-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#static-data-order-type">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="static-data-order-type">
                          Order Type
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#static-data-ot-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-ot-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-ot-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Response Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#static-data-ot-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#static-data-ot-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#static-data-locate-time-in-force">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="static-data-locate-time-in-force">
                          Locate Time In Force
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#static-data-ltif-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-ltif-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-ltif-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Response Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#static-data-ltif-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#static-data-ltif-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#static-data-destination">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="static-data-destination">
                          Destination
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#static-data-dest-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-dest-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-dest-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Response Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#static-data-dest-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#static-data-dest-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#static-data-option-destination">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="static-data-option-destination">
                          Option Destination
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#static-data-opt-dest-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-opt-dest-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-opt-dest-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Response Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#static-data-opt-dest-body">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#static-data-opt-dest-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#static-data-opt-ord-type">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="static-data-opt-ord-type">
                          Option Order Type
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#static-data-opt-ord-type-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-opt-ord-type-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-opt-dest-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Response Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#static-data-opt-ord-type-body">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#static-data-opt-ord-type-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#static-data-opt-time-in-force">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="static-data-opt-time-in-force">
                          Option Time In Force
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#static-data-opt-time-in-force-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-opt-time-in-force-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-opt-time-in-force-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Response Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#static-data-opt-time-in-force-body">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#static-data-opt-time-in-force-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#static-data-put-call">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="static-data-put-call">
                          Put Call
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#static-data-put-call-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-put-call-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-opt-time-in-force-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Response Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#static-data-put-call-body">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#static-data-put-call-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#static-data-covered-uncovered">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="static-data-covered-uncovered">
                          Covered Uncovered
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#static-data-covered-uncovered-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-covered-uncovered-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-covered-uncovered-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Response Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#static-data-covered-uncovered-body">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#static-data-covered-uncovered-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#static-data-customer-firm">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="static-data-customer-firm">
                          Customer Firm
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#static-data-customer-firm-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-customer-firm-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#static-data-customer-firm-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Response Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#static-data-customer-firm-body">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#static-data-customer-firm-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#orders">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="orders">
                      Orders
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <span className="caret">
                    <a href="#orders-add-order">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="orders-add-order">
                          Add Order
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#orders-add-order-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#orders-add-order-req-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#orders-add-order-req-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#orders-add-order-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#orders-add-order-accepted">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 202 (Accepted)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#orders-add-order-bad">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#orders-update-order">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="orders-update-order">
                          Update Order
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#orders-update-order-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#orders-update-order-req-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#orders-update-order-req-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#orders-update-order-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#orders-update-order-bad">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#orders-cancel-order-deprecated">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="orders-cancel-order-deprecated">
                          Cancel Order (Deprecated)
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#orders-cancel-order-deprecated-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#orders-cancel-order-deprecated-req-params">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Params
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#orders-cancel-order-deprecated-req-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#orders-cancel-order-deprecated-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#orders-cancel-order-deprecated-bad">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#orders-cancel-order">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="orders-cancel-order">
                          Cancel Order
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#orders-cancel-order-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#orders-cancel-order-req-params">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Params
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#orders-cancel-order-req-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#orders-cancel-order-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#orders-cancel-order-bad">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#option-orders">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="option-orders">
                      Option Orders
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <span className="caret">
                    <a href="#add-option-order">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="add-option-order">
                          Add Options Order
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#option-orders-add-options-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#option-orders-add-options-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#option-orders-add-options-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#option-orders-add-options-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#option-orders-add-options-accepted">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 202 (Accepted)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#option-orders-add-options-error">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#update-option-order">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="update-option-order">
                          Update Options Order
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#option-orders-update-options-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#option-orders-update-options-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#option-orders-update-options-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#option-update-add-options-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#option-update-add-options-error">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#cancel-option-order-deprecated">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="cancel-option-order-deprecated">
                          Cancel Option Order (Deprecated)
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#cancel-option-order-deprecated-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#cancel-option-order-deprecated-req-params">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Params
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#cancel-option-order-deprecated-req-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#cancel-option-order-deprecated-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#cancel-option-order-deprecated-bad">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#cancel-option-order">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="cancel-option-order">
                          Cancel Option Order
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#option-orders-cancel-options-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#option-orders-cancel-options-req-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#option-orders-cancel-options-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#option-cancel-add-options-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#option-cancel-add-options-error">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#locates">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="locates">
                      Locates
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <span className="caret">
                    <a href="#locate-request">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="locate-request">
                          Locate Request
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#locate-request-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#locate-request-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#locate-request-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#locate-request-bad-request">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#locate-acquire">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="locate-acquire">
                          Locate Acquire
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#locate-acquire-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#locate-acquire-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#locate-acquire-body">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Body
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#locate-acquire-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#locate-acquire-bad-request">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#locates-subscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="locates-subscribe">
                          Locates Subscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#locate-subscribe-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#locate-subscribe-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#locate-subscribe-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#locate-subscribe-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#locates-unsubscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="locates-unsubscribe">
                          Locates Unsubscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#locate-unsubscribe-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#locate-unsubscribe-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#locate-unsubscribe-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#locates-summary-subscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="locates-summary-subscribe">
                          Locates Summary Subscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#locate-summary-subscribe-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#locate-summary-subscribe-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#locate-summary-subscribe-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#locate-summary-subscribe-no-content">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 204 (No Content)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#locates-summary-unsubscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="locates-summary-unsubscribe">
                          Locates Summary Unsubscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#locate-summary-unsubscribe-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#locate-summary-unsubscribe-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#locate-summary-unsubscribe-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#orders-subscriptions">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="orders-subscriptions">
                      Orders Subscriptions
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <span className="caret">
                    <a href="#order-subscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="order-subscribe">
                          Orders Subscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#orders-subscribes-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#orders-subscribes-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#orders-subscribes-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#orders-subscribes-bad-request">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#orders-unsubscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="orders-unsubscribe">
                          Orders Unsubscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#orders-unsubscribes-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#orders-unsubscribes-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#orders-unsubscribes-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#orders-unsubscribes-bad-request">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#option-orders-subscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="option-orders-subscribe">
                          Option Orders Subscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#option-orders-subscribe-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#option-orders-subscribe-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#option-orders-subscribe-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#option-orders-subscribe-bad-request">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#option-orders-unsubscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="option-orders-unsubscribe">
                          Option Orders Unsubscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#option-orders-unsubscribe-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#option-orders-unsubscribe-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#option-orders-unsubscribe-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#option-orders-unsubscribe-bad-request">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#open-orders-subscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="open-orders-subscribe">
                          Open Orders Subscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#open-orders-subscribe-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#open-orders-subscribe-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#open-orders-subscribe-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#open-orders-subscribe-bad-request">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#open-orders-unsubscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="open-orders-unsubscribe">
                          Open Orders Unsubscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#open-orders-unsubscribe-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#open-orders-unsubscribe-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#open-orders-unsubscribe-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#open-orders-unsubscribe-bad-request">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#executions-subscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="executions-subscribe">
                          Executions Subscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#executions-subscribe-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#executions-subscribe-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#executions-subscribe-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#executions-subscribe-error">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#executions-unsubscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="executions-unsubscribe">
                          Executions Unsubscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#executions-unsubscribe-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#executions-unsubscribe-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#executions-unsubscribe-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#executions-unsubscribe-bad-request">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#positions-subscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="positions-subscribe">
                          Positions Subscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#positions-subscribe-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#positions-subscribe-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#positions-subscribe-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#positions-subscribe-bad-request">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <span className="caret">
                    <a href="#positions-unsubscribe">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="positions-unsubscribe">
                          Positions Unsubscribe
                          <KeyboardArrowRightIcon />
                        </div>
                      </MDTypography>
                    </a>
                  </span>
                  <ul className="nested">
                    <li>
                      <a href="#positions-unsubscribe-endpoint">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Endpoint
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href="#positions-unsubscribe-headers">
                        <span className="caret">
                          <MDTypography
                            variant="h6"
                            fontSize="13px"
                            fontWeight="regular"
                            fontFamily="inherit"
                          >
                            Request Headers
                          </MDTypography>
                        </span>
                      </a>
                    </li>
                    <li>
                      <span className="caret">
                        <MDTypography
                          variant="h6"
                          fontSize="13px"
                          fontWeight="regular"
                          fontFamily="inherit"
                        >
                          Status
                          <KeyboardArrowRightIcon />
                        </MDTypography>
                      </span>
                      <ul className="nested">
                        <li>
                          <a href="#positions-unsubscribe-success">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 200 (Success)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                        <li>
                          <a href="#positions-unsubscribe-bad-request">
                            <span className="caret">
                              <MDTypography
                                variant="h6"
                                fontSize="13px"
                                fontWeight="regular"
                                fontFamily="inherit"
                              >
                                Status Code: 400 (Bad Request)
                              </MDTypography>
                            </span>
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#web-socket-hub">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="web-socket-hub">
                      Web Socket Hub
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <a href="#web-socket-hub-endpoint">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        Handshake Endpoint
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#wse-request-query-params">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        Request Query Params
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#wse-message-format">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        Message Format
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#wse-sample-code">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        Sample Code
                      </MDTypography>
                    </span>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <span className="caret">
                <a href="#web-socket-hub-with-signalr">
                  <MDTypography
                    variant="h6"
                    fontSize="13px"
                    fontWeight="regular"
                    fontFamily="inherit"
                  >
                    <div data-to-scrollspy-id="web-socket-hub-with-signalr">
                      Web Socket Hub with SignalR
                      <KeyboardArrowRightIcon />
                    </div>
                  </MDTypography>
                </a>
              </span>
              <ul className="nested">
                <li>
                  <a href="#web-socket-hub-with-signalr-endpoint">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="web-socket-hub-with-signalr-endpoint">
                          Handshake Endpoint
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#ws-http-connection-options">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="ws-http-connection-options">
                          HTTP Connection Options
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#ws-sample-code">
                    <span className="caret">
                      <MDTypography
                        variant="h6"
                        fontSize="13px"
                        fontWeight="regular"
                        fontFamily="inherit"
                      >
                        <div data-to-scrollspy-id="ws-sample-code">
                          Sample Code
                        </div>
                      </MDTypography>
                    </span>
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#sample-flow">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="sample-flow">Sample Flow</div>
                </MDTypography>
              </a>
            </li>
            <li>
              <a href="#support">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="support">Support</div>
                </MDTypography>
              </a>
            </li>
            <li>
              <a href="#disclaimer-and-confidentiality-notice">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="disclaimer-and-confidentiality-notice">
                    Disclaimer and Confidentiality Notice
                  </div>
                </MDTypography>
              </a>
            </li>
          </ul>
          <li className=" docs-nav ver-nav">
            <span className="caret">
              <Link to="/products/trading-api-v2.5.1">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="version">
                    Trading API - v2.5.1
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </Link>
            </span>
          </li>
          <li className=" docs-nav ver-nav">
            <span className="caret">
              <Link to="/products/trading-api-v2.5">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="version">
                    Trading API - v2.5
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </Link>
            </span>
          </li>
          <li className=" docs-nav ver-nav">
            <span className="caret">
              <Link to="/products/trading-api-v2.4">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="version">
                    Trading API - v2.4
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </Link>
            </span>
          </li>
          <li className=" docs-nav ver-nav">
            <span className="caret">
              <Link to="/products/trading-api-v2.3">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="version">
                    Trading API - v2.3
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </Link>
            </span>
          </li>
          <li className=" docs-nav ver-nav">
            <span className="caret">
              <Link to="/products/trading-api-v2.2.4">
                <MDTypography
                  variant="h6"
                  fontSize="13px"
                  fontWeight="regular"
                  fontFamily="inherit"
                >
                  <div data-to-scrollspy-id="version">
                    Trading API - v2.2.4
                    <KeyboardArrowRightIcon />
                  </div>
                </MDTypography>
              </Link>
            </span>
          </li>
        </li>
        {/* <MDTypography
            variant="h6"
            fontSize="13px"
            fontWeight="medium"
            fontFamily="inherit"
            className="nav-footer"
          >
            Trading API - 2.2.4
          </MDTypography> */}
      </MDTypography>
    </>
  );
}
MultiSelectTreeView.propTypes = {
  searchedData: PropTypes.func.isRequired,
};

export default MultiSelectTreeView;
